import React from 'react';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

import App from './App.jsx';
import { Provider } from 'react-redux';
import { store } from './redux/store.js';
import { getLogged } from './redux/main/authSlice.js'; // Importa l'azione getLogged
import { getAccountDetails, getEnvInfo } from './redux/main/accountSlice.js'; // Importa l'azione getAccountDetails
import { getUserDetails } from './redux/main/userSlice.js'; // Importa l'azione getUserDetails
import { audioRecorder } from './utils/audioRecorder.js'; // Importa l'utility audioRecorder
// fontawesome
import './utils/fontawesome.js'; // Importa la configurazione di Font Awesome
import '@fortawesome/fontawesome-svg-core/styles.css';
import { config } from '@fortawesome/fontawesome-svg-core';

// Previene il flickering delle icone
config.autoAddCss = false;

// Controlla se l'utente è già loggato all'avvio
const token = localStorage.getItem('installamelo-auth-token');
const userString = localStorage.getItem('installamelo-auth-user');

if (token && userString) {
  try {
    const user = JSON.parse(userString);
    // Dispatcha l'azione per impostare lo stato come loggato
    store.dispatch(getLogged(user));
    
    // Carica info ambiente (test o produzione)
    store.dispatch(getEnvInfo());

    // Carica anche i dati dell'account e dell'utente
    if (user && user.accountId) {
      // Carica i dati dell'account
      store.dispatch(getAccountDetails({
        accountId: user.accountId,
        token: token
      }));
      
      // Carica i dati dell'utente
      if (user.userId) {
        store.dispatch(getUserDetails({
          accountId: user.accountId,
          userId: user.userId,
          token: token
        }));
      }
    }
  } catch (error) {
    console.error("Errore nel parsing dei dati utente da localStorage:", error);
    // Opzionale: pulire localStorage se i dati sono corrotti
    localStorage.removeItem('installamelo-auth-token');
    localStorage.removeItem('installamelo-auth-user');
  }
}


createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>,
)

// Associazione evento click per avviare/interrompere la registrazione audio
document.addEventListener("DOMContentLoaded", () => {
  const audioBtn = document.getElementById("makeAudioRequestBtn");
  if(audioBtn) {
    audioBtn.addEventListener("click", () => {
      // Usa il nuovo audioRecorder con ID del bottone, ID del container spinner e ID della textarea
      audioRecorder.toggleRecording("makeAudioRequestBtn", "makeAudioRequestBtnSpinnerContainer", "textAreaToUpdate");
      // Nota: sostituisci "textAreaToUpdate" con l'ID effettivo della textarea da aggiornare
    });
  }
});
